<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div>
        <Row class="table-style-size">
            <i-col span="5">时间</i-col>
            <i-col span="5">金额</i-col>
            <i-col span="5">操作</i-col>
            <i-col span="9">备注</i-col>
        </Row>
        <div v-if="records.length>0">
            <div style="height:528px">
                <Row class="table-style-size table-style-body" style="height:65px" v-for="(item,index) in records" :key="index">
                    <i-col span="5">{{item.payDate}}</i-col>
                    <i-col span="5">{{item.redEnvelopeAmount}}</i-col>
                    <i-col span="5">{{item.bizType}}</i-col>
                    <i-col span="9">{{item.processedRemarks}}</i-col>
                </Row>
            </div>
            <div class="commont-page" style="margin-top:30px">
                <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
            <p>表单暂无数据哦～</p>
        </div>
    </div>

</template>

<script>
import { _getRedEnvelope } from "@/api/wallet.js";
import Cookies from "js-cookie";
export default {
    name:'walletRedMoney',
    data(){
        return{
            total:0,
            pages:0,
            pageNumber:1,
            pageSize:8,
            records:[],
            flag:false
        }
    },
    props:["tip"],
    methods: {
        findByPage(){
            this.$nextTick(function(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data={
                    pageNumber:this.pageNumber,
                    pageSize:this.pageSize,
                    sort:'create_date',
                    order:'desc',
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    enterOrOut:this.tip==1?true:false
                }
                _getRedEnvelope(data).then(res => {
                    if(res.code==200){
                        this.total=Number(res.result.total);
                        this.pages=res.result.pages;
                        this.records = res.result.records.map(item => {

                          if (item.subBizType === '0604') {
                            item.processedRemarks = this.processRemarks(item.remarks);
                          } else {
                            item.processedRemarks = item.remarks || ''; // 非0604也兜底空值
                          }
                          return item;
                        });
                        this.flag=true;
                    }

                });
            })
        },
        //分页
        changepage(index){
            this.pageNumber = index;
            this.findByPage()
        },
        processRemarks(remarks) {
          if (!remarks) return ''; // 空值兜底
          const arr = remarks.split('，');
          // 仅长度为4时删除第1（索引0）、3（索引2）个元素
          return arr.length === 4
              ? arr.filter((_, idx) => idx !== 1 && idx !== 3).join('，')
              : remarks;
        },
    },
    mounted() {
        this.findByPage()
    },
}
</script>
